module.exports = __webpack_public_path__ + "img/hgnh.fd18b54b.jpg";